import { DocumentVerificationPassedDetails } from '@/bundle/shared/components/DocumentVerificationPassedDetails/DocumentVerificationPassedDetails';
import { ButtonNew } from '@/components-new/ButtonNew/ButtonNew';
import { Dialog } from '@/components-new/Dialog/Dialog';
import { DialogButtons } from '@/components-new/Dialog/styles';
import { Box } from '@/components/Box/Box';
import { DetailsRow } from '@/components/DetailsWidget/DetailsRow/DetailsRow';
import { DetailsWidget } from '@/components/DetailsWidget/DetailsWidget';
import { Typography } from '@/components/Typography/Typography';
import { DATE_TIME_FORMAT, formatDate } from '@/helpers/dateHelpers/dateHelpers';
import { SecureLinkVerificationType } from '@/types/myVaultTypes';

export type IdVerificationRecordDialogType = {
  isOpen: boolean;
  record: SecureLinkVerificationType;
  onClose: () => void;
  isLoading: boolean;
};

export const IdVerificationRecordDialog = ({ isOpen, onClose, record, isLoading }: IdVerificationRecordDialogType) => {
  return (
    <Dialog isOpen={isOpen} header='ID verification' width='640px' onClose={onClose}>
      <DetailsWidget header={record?.role ?? 'Recipient'} isLoading={isLoading} marker='ID VERIFICATION'>
        {record && (
          <>
            {[
              ['First name', record.first_name],
              ['Middle name', record.middle_name || '-'],
              ['Last name', record.last_name],
              ['Email address', record.email || '-'],
              ['Mobile phone number', record.phone_masked],
            ].map(([name, value]) => (
              <DetailsRow key={name} name={name}>
                {value}
              </DetailsRow>
            ))}
          </>
        )}
      </DetailsWidget>

      {record && (
        <Box marginTop='16px'>
          <DocumentVerificationPassedDetails fullName={record.name_from_document} />

          <Typography variant='caption' marginTop='16px'>
            {formatDate(record.date_modified, DATE_TIME_FORMAT)} · Result hash {record.raw_result_hash.slice(0, 12)}.
          </Typography>
        </Box>
      )}

      <DialogButtons>
        <ButtonNew onClick={onClose}>Close</ButtonNew>
      </DialogButtons>
    </Dialog>
  );
};
